import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HowItWorks.css';

const HowItWorks = () => {
  const navigate = useNavigate();

  const steps = [
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
      ),
      title: 'Create Your Free Profile',
      description: 'Sign up in under 2 minutes with just your email. No credit card required, no hidden fees. Start building your professional presence immediately and join a community of ambitious professionals ready to advance their careers.'
    },
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
          <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
        </svg>
      ),
      title: 'Showcase Your Skills & Experience',
      description: 'Build a compelling profile that highlights your expertise, achievements, and unique value. Upload your portfolio, list your skills, and let employers discover why you\'re the perfect fit for their team. Stand out from the crowd with a professional profile.'
    },
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
      ),
      title: 'Discover Opportunities',
      description: 'Get matched with job opportunities tailored to your skills and career goals. Our intelligent platform connects you with employers actively seeking talent like you. Browse curated listings, set job alerts, and never miss your dream opportunity.'
    },
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
      ),
      title: 'Connect & Grow Your Career',
      description: 'Communicate directly with employers, schedule interviews, and build meaningful professional relationships. Track your applications, receive real-time updates, and take control of your career journey with tools designed for success.'
    }
  ];

  const handleGetStarted = () => {
    navigate('/signup');
  };

  return (
    <section id="how-it-works" className="how-it-works">
      <div className="container">
        <div className="section-header">
          <h2>How It Works</h2>
          <p>Your path to career success starts here. Join thousands of professionals who are already advancing their careers.</p>
        </div>
        <div className="steps-container">
          {steps.map((step, index) => (
            <div key={index} className="step">
              <div className="step-icon-wrapper">
                <div className="step-icon">{step.icon}</div>
              </div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
              {index < steps.length - 1 && <div className="step-arrow">→</div>}
            </div>
          ))}
        </div>
        <div className="cta-section">
          <h3>Ready to Transform Your Career?</h3>
          <p>Join Your Personal Career Copilot today and unlock unlimited opportunities. Start connecting with top employers, showcase your expertise, and take the next step in your professional journey. Your future starts now.</p>
          <div className="cta-benefits">
            <div className="cta-benefit">✓ 100% Free to Join</div>
            <div className="cta-benefit">✓ Verified Employers</div>
            <div className="cta-benefit">✓ Career Growth Tools</div>
            <div className="cta-benefit">✓ Direct Communication</div>
          </div>
          <button onClick={handleGetStarted} className="cta-button">
            Get Started Free
          </button>
          <p className="cta-note">No credit card required • Set up in minutes • Start applying today</p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
